import { MessageCircle } from "lucide-react";
import { SITE } from "@/lib/site";
import { useActiveLang } from "@/hooks/use-active-lang";

export const WA24_LABEL = {
  es: "Atención 24/7 por WhatsApp",
  en: "24/7 support on WhatsApp",
  fr: "Assistance 24h/24 et 7j/7 sur WhatsApp",
  pt: "Atendimento 24/7 pelo WhatsApp",
  it: "Assistenza 24/7 su WhatsApp",
  de: "24/7-Hilfe per WhatsApp",
} as const;

/** Línea "Atención 24/7 por WhatsApp" con enlace directo a WhatsApp. */
export function WhatsApp24({ className = "", onDark = false }: { className?: string; onDark?: boolean }) {
  const lang = useActiveLang();
  const label = WA24_LABEL[lang as keyof typeof WA24_LABEL] ?? WA24_LABEL.es;
  return (
    <a
      href={SITE.contact.whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className={`inline-flex min-h-[40px] items-center gap-2 rounded-full border px-4 text-sm font-semibold transition-colors ${
        onDark ? "border-border/30 text-background hover:bg-background/10" : "border-border bg-card text-foreground hover:border-primary"
      } ${className}`}
    >
      <MessageCircle className="h-4 w-4 text-primary" aria-hidden />
      {label}
    </a>
  );
}
